<div class="modal-container">

  <div class="modal-header">
    <span class="modal-header-title">
      {{ 'eAddToCart.addToCartDialog.title' | cxTranslate }}
    </span>
    <button type="button" class="close pull-right" aria-label="Close" (click)="closeModal(dialogCloseStatus.CLOSED_ROUTE_TO_SAME_PAGE)">
      <cx-icon [type]="iconType.CLOSE_LIGHT"></cx-icon>
      <span class="c-btn-close-text">{{ 'eAddToCart.addToCartDialog.actions.close' | cxTranslate }}</span>
    </button>
  </div>
  <div class="modal-body">
    <div class="outer-container">
      @if ((loaded$| async)) {
        <table class="table table--responsive mb-0">
          <thead>
            <tr>
              <th scope="col" class="text-left cartItems-item">{{ 'cartItems.item' | cxTranslate }}</th>
              <th scope="col" class="text-left cartItems-quantity">{{ 'cartItems.quantity' | cxTranslate }}</th>
              <th scope="col" class="text-left cartItems-itemPriceRrp">{{ 'cartItems.itemPriceRrp' | cxTranslate }}</th>
              <th scope="col" class="text-left cartItems-total">{{ 'cartItems.total' | cxTranslate }}</th>
            </tr>
          </thead>
          <tbody>
            <tr>
              <td attr.data-label="{{ 'cartItems.item' | cxTranslate }}">
                <!-- Item Name -->
                @if (product.name) {
                  <div class="article-name">
                    <span>{{ product.name }}</span>
                  </div>
                }
                <!-- Item Code -->
                @if (product.manufacturerAID) {
                  <div class="article-code">
                    {{ product.manufacturerAID }}
                    @if (product.manufacturer) {
                      <span>&nbsp;/&nbsp;{{
                      product.manufacturer }}</span>
                    } @else {
                      @if (product.manufacturerId) {
                        <span>&nbsp;/&nbsp;{{ product.manufacturerId
                        }}</span>
                      }
                    }
                  </div>
                }
              </td>
              <!-- Item Quantity -->
              <td attr.data-label="{{ 'cartItems.quantity' | cxTranslate }}">
                <app-efa-item-counter class="quantity-selector" [control]="addToCartForm.get('quantity')" [readonly]="false"
                  [allowZero]="true">
                </app-efa-item-counter>
              </td>
              <!-- Item Price -->
              <td attr.data-label="{{ 'cartItems.itemPriceRrp' | cxTranslate }}">@if (listPricePerUnit) {
                <span
                class="price-dialog">{{ listPricePerUnit.formattedValue }}</span>
              }</td>
              <!-- Total Price -->
              <td attr.data-label="{{ 'cartItems.total' | cxTranslate }}">@if (totalPrice) {
                <span
                  class="price-dialog">{{ totalPrice.value |
                currency:totalPrice.currencyIso:'symbol':'1.2-2':language }}</span>
              }</td>
            </tr>
          </tbody>
        </table>
      } @else {
        <cx-spinner></cx-spinner>
      }

    </div>
  </div>

  <div class="modal-footer">
    <button class="btn btn-secondary c-btn-add-to-cart" type="button" (click)="addToCart(dialogCloseStatus.SUCCESS_ROUTE_TO_CONFIGURED_PAGE)"
      [disabled]="!(loaded$ | async)">
      {{ 'eAddToCart.addToCartDialog.actions.goToCart' | cxTranslate }}
    </button>
    <button class="btn btn-primary c-btn-add-to-cart" type="button" (click)="addToCart(dialogCloseStatus.SUCCESS_ROUTE_TO_SAME_PAGE)"
      [disabled]="!(loaded$ | async)">
      {{ 'eAddToCart.addToCartDialog.actions.returnToCurrentPage' | cxTranslate }}
    </button>
  </div>
</div>
